import { jsPDF } from 'jspdf';

// Renders a signed agreement's verbatim text to a downloadable PDF — serif type,
// centered title, bold headings, justified-ish body, auto-paginated. Faithful to
// the legally-binding text (the styling mirrors the master lease PDF).
export function downloadAgreementPdf(text: string, filename: string) {
  const doc = new jsPDF({ unit: 'pt', format: 'letter' });
  const margin = 56;
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const width = pageW - margin * 2;

  const lines = text.split('\n');
  let y = margin;
  const newPageIfNeeded = (h: number) => {
    if (y + h > pageH - margin) {
      doc.addPage();
      y = margin;
    }
  };

  lines.forEach((raw, i) => {
    const line = raw.replace(/\s+$/, '');
    if (!line) {
      y += 6;
      return;
    }
    // First two non-empty lines = centered title / subtitle.
    if (i === 0) {
      doc.setFont('times', 'bold');
      doc.setFontSize(15);
      newPageIfNeeded(20);
      doc.text(line, pageW / 2, y, { align: 'center' });
      y += 20;
      return;
    }
    if (i === 1) {
      doc.setFont('times', 'normal');
      doc.setFontSize(11);
      newPageIfNeeded(16);
      doc.text(line, pageW / 2, y, { align: 'center' });
      y += 18;
      return;
    }
    const isHeading =
      /^\d{1,2}\.\s+[A-Z]/.test(line) || /^(RECITALS|ACKNOWLEDGMENT|PROMO PLAN ADDENDUM)/.test(line);
    doc.setFont('times', isHeading ? 'bold' : 'normal');
    doc.setFontSize(10);
    if (isHeading) y += 4;
    const wrapped: string[] = doc.splitTextToSize(line, width);
    wrapped.forEach((w) => {
      newPageIfNeeded(13);
      doc.text(w, margin, y);
      y += 13;
    });
    if (isHeading) y += 1;
  });

  doc.save(filename);
}
